"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpPerformQuestionDateTime = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const usePerform_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformController/usePerform"));
const usePerformActions_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformController/usePerformActions"));
const usePerformQuestion_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestion"));
const usePerformQuestionActions_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestionActions"));
const useForceUpdate_1 = __importDefault(require("@opsbase/react-hooks/useForceUpdate"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const DatePicker_1 = __importDefault(require("@opsbase/web-pickers/DatePicker"));
const DateTimePicker_1 = __importDefault(require("@opsbase/web-pickers/DatePicker/DateTimePicker"));
const TimePicker_1 = __importDefault(require("@opsbase/web-pickers/DatePicker/TimePicker"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text/Text"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const react_1 = __importStar(require("react"));
const consts_1 = require("../../consts");
const OpPerformQuestionCard_1 = __importDefault(require("../../OpPerformQuestionCard"));
function OpPerformQuestionDateTime(props) {
    const { rule, answer } = (0, usePerformQuestion_1.default)();
    const { doChangeAnswer } = (0, usePerformQuestionActions_1.default)();
    const { doSetHasError } = (0, usePerformActions_1.default)();
    const { forceUpdate } = (0, useForceUpdate_1.default)();
    const answerValue = (answer === null || answer === void 0 ? void 0 : answer.value) ? (0, moment_timezone_1.default)(answer.value) : undefined;
    const { mode } = (0, usePerform_1.default)();
    const viewMode = mode === 'view';
    const [error, setError] = (0, react_1.useState)('');
    const handleChange = (0, react_1.useCallback)(value => {
        if (rule.preventFutureDate && (0, moment_timezone_1.default)(value).isAfter((0, moment_timezone_1.default)())) {
            setError(lib_i18n_1.default.t('error-invalid-future-date'));
            doSetHasError(true);
        }
        else {
            setError('');
            doSetHasError(false);
        }
        doChangeAnswer({ value });
        forceUpdate();
    }, [rule, doChangeAnswer, forceUpdate, doSetHasError]);
    return (0, react_1.useMemo)(() => {
        let Picker = DatePicker_1.default;
        if (rule.isDateRequired && rule.isTimeRequired)
            Picker = DateTimePicker_1.default;
        if (rule.isTimeRequired && !rule.isDateRequired)
            Picker = TimePicker_1.default;
        return (react_1.default.createElement(OpPerformQuestionCard_1.default, Object.assign({}, props, { disableChildren: viewMode }),
            error && react_1.default.createElement(Text_1.default, { color: 'error' }, error),
            react_1.default.createElement(Pane_1.default, { center: true, padding: true },
                react_1.default.createElement(Picker, { noMargin: viewMode, value: answerValue, onChange: handleChange, style: consts_1.performInputStyle }))));
    }, [rule, props, viewMode, error, answerValue, handleChange]);
}
exports.OpPerformQuestionDateTime = OpPerformQuestionDateTime;
exports.default = OpPerformQuestionDateTime;
